export class ElementType{
    static MemberType = new ElementType("members")
    static EventType = new ElementType("events")
    static ArticleType = new ElementType("news")
    static PhotoType = new ElementType("photos")

    constructor(elementName){
        this.elementName = elementName;
    }
}